import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useFocus } from '@alfalab/hooks';

var defaultColors = {"component":"tag__component_1y2kj","outlined":"tag__outlined_1y2kj","filled":"tag__filled_1y2kj","checked":"tag__checked_1y2kj"};
require('./default.css')

var commonStyles = {"component":"tag__component_16b6c","focused":"tag__focused_16b6c","addons":"tag__addons_16b6c","size-48":"tag__size-48_16b6c","size-56":"tag__size-56_16b6c","size-64":"tag__size-64_16b6c","size-72":"tag__size-72_16b6c","size-32":"tag__size-32_16b6c","size-40":"tag__size-40_16b6c","withRightAddons":"tag__withRightAddons_16b6c","withLeftAddons":"tag__withLeftAddons_16b6c","rounded":"tag__rounded_16b6c","allowBackdropBlur":"tag__allowBackdropBlur_16b6c","outlined":"tag__outlined_16b6c","checked":"tag__checked_16b6c","filled":"tag__filled_16b6c"};
require('./index.css')

var invertedColors = {"component":"tag__component_1gi3t","outlined":"tag__outlined_1gi3t","filled":"tag__filled_1gi3t","checked":"tag__checked_1gi3t"};
require('./inverted.css')

var colorCommonStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SIZE_TO_CLASSNAME_MAP = {
    xxs: 'size-32',
    xs: 'size-40',
    s: 'size-48',
    m: 'size-56',
    l: 'size-64',
    xl: 'size-72',
    32: 'size-32',
    40: 'size-40',
    48: 'size-48',
    56: 'size-56',
    64: 'size-64',
    72: 'size-72',
};
var BaseTag = forwardRef(function (_a, ref) {
    var _b;
    var allowBackdropBlur = _a.allowBackdropBlur, rightAddons = _a.rightAddons, leftAddons = _a.leftAddons, children = _a.children, _c = _a.size, size = _c === void 0 ? 48 : _c, checked = _a.checked, className = _a.className, dataTestId = _a.dataTestId, name = _a.name, _d = _a.colors, colors = _d === void 0 ? 'default' : _d, onClick = _a.onClick, _e = _a.variant, variant = _e === void 0 ? 'default' : _e, shape = _a.shape, _f = _a.view, view = _f === void 0 ? 'outlined' : _f, childrenClassName = _a.childrenClassName, childrenRef = _a.childrenRef, _g = _a.styles, styles = _g === void 0 ? {} : _g, _h = _a.colorStylesMap, colorStylesMap = _h === void 0 ? { default: {}, inverted: {} } : _h, restProps = __rest(_a, ["allowBackdropBlur", "rightAddons", "leftAddons", "children", "size", "checked", "className", "dataTestId", "name", "colors", "onClick", "variant", "shape", "view", "childrenClassName", "childrenRef", "styles", "colorStylesMap"]);
    var colorStyles = colorStylesMap[colors];
    var tagRef = useRef(null);
    var focused = useFocus(tagRef, 'keyboard')[0];
    var variantClassName = variant === 'default' ? 'rounded' : 'rectangular';
    var shapeClassName = shape || variantClassName;
    var tagProps = {
        className: cn(commonStyles.component, colorCommonStyles[colors].component, colorStyles.component, commonStyles[SIZE_TO_CLASSNAME_MAP[size]], styles[SIZE_TO_CLASSNAME_MAP[size]], colorCommonStyles[colors][view], commonStyles[view], (_b = {},
            _b[commonStyles.allowBackdropBlur] = allowBackdropBlur,
            _b[commonStyles.checked] = checked,
            _b[commonStyles[shapeClassName]] = Boolean(commonStyles[shapeClassName]),
            _b[styles[shapeClassName]] = Boolean(styles[shapeClassName]),
            _b[colorCommonStyles[colors].checked] = checked,
            _b[colorStyles[view]] = Boolean(colorStyles[view]),
            _b[commonStyles.focused] = focused,
            _b[commonStyles.withRightAddons] = Boolean(rightAddons),
            _b[commonStyles.withLeftAddons] = Boolean(leftAddons),
            _b), className),
        'data-test-id': dataTestId,
    };
    var handleClick = function (event) {
        if (onClick) {
            onClick(event, { name: name, checked: !checked });
        }
    };
    return (React.createElement("button", __assign({ ref: mergeRefs([tagRef, ref]), type: 'button', onClick: handleClick }, tagProps, restProps),
        leftAddons ? React.createElement("span", { className: commonStyles.addons }, leftAddons) : null,
        children && (React.createElement("span", { ref: childrenRef, className: childrenClassName }, children)),
        rightAddons ? React.createElement("span", { className: commonStyles.addons }, rightAddons) : null));
});

export { BaseTag };
